module.exports = __webpack_public_path__ + "static/media/5.8adf79df.jpg";